import InputControl from '../InputControl/InputControl';
import IconBin from '../Icons/IconBin/IconBin';
import { MetaField } from '../../store/models/cycles';

interface FieldInputProps {
  field: MetaField;
  onChange?: (updatedField: MetaField) => void;
  onRemove?: (key: string) => void;
  onUpdate?: (updatedField: MetaField) => void;
  originalField?: MetaField;
  keyError?: string | null,
  valueError?: string | null;
}

export const FieldInput = ({ field, onChange, onRemove, onUpdate, originalField, keyError, valueError }: FieldInputProps) => {
  const isFieldChanged = originalField && (field.key !== originalField.key || field.value !== originalField.value);

  return (
    <div className="flex w-full items-center gap-4 field-input">
      <div className="flex-1">
        <InputControl
          label="Key"
          placeholder="Enter key"
          value={field.key}
          errorText={keyError || ''}
          showError={Boolean(keyError)}
          onChange={(e) => {
            const updatedField = { ...field, key: e.target.value };
            onChange?.(updatedField);
            onUpdate?.(updatedField);
          }}
        />
      </div>
      <div className="flex-1">
        <InputControl
          label="Value"
          placeholder="Enter value"
          value={field.value}
          errorText={valueError || ''}
          showError={Boolean(valueError)}
          onChange={(e) => {
            const updatedField = { ...field, value: e.target.value };
            onChange?.(updatedField);
            onUpdate?.(updatedField);
          }}
        />
      </div>
      {onRemove && !isFieldChanged && (
        <button onClick={() => onRemove(field.key)} className=" text-meta-1 hover:text-meta-1/80">
          <IconBin />
        </button>
      )}
    </div>
  );
};